import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { node, shape } from 'prop-types';

import { useReactToPrint } from '../reactToPrint';

import styles from './styles.module.scss';

export function Print({ componentToPrint, reactToPrintProps = {} }) {
  const componentRef = useRef(null);
  const content = useCallback(() => componentRef.current, []);
  const printProps = useMemo(() => ({ ...reactToPrintProps, content }), [reactToPrintProps, content]);
  const handlePrint = useReactToPrint(printProps);

  useEffect(() => {
    let timeoutId = null;
    if (componentRef.current) {
      timeoutId = setTimeout(handlePrint, 0);
    }

    return () => timeoutId && clearTimeout(timeoutId);
  }, [handlePrint]);

  return (
    <div className={styles.hide}>
      <div ref={componentRef}>{componentToPrint}</div>
    </div>
  );
}

Print.propTypes = {
  componentToPrint: node,
  reactToPrintProps: shape({})
};
